import { fetchData } from "@redux/slices/functionals/request/requestActions";
import { GroupDto } from "@ts/dtos";

export const getGroupById = async (dispatch, id: string, source: 'cloud' | 'edge' = 'cloud'): Promise<GroupDto | null> => {
    let data: any | null = null;
    if (source === 'cloud') {
        const result = await dispatch(
            fetchData({
                url: `/api/v3/group/${id}`,
            })
        );

        if (result?.payload?.data) {
            return result.payload.data.data;
        }
        return data;
    }
    return data;
};